var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.352 4 .31.007c2.73.142 4.964 2.385 5.3 5.335l.023.247.015.388v27.986c0 2.977-2.061 5.445-4.762 5.916l-.227.035-.126.014-.09.024-.101.02-.105.016-.216.012H13.662c-3.052 0-5.53-2.565-5.644-5.767l-.004-.202L8 37.986l.014-.069V10.015C7.99 7.056 10 4.578 12.733 4.085l.23-.037.331-.036.35-.012h20.708zM13.897 8l-.207.007c-.91.072-1.624.852-1.686 1.836L12 10v27.986l.012.245c.093.871.693 1.568 1.472 1.736l.148.025.215.013h19.918l.155-.027.43-.028c.88-.118 1.572-.885 1.642-1.825l.006-.159L36 10.071l-.008-.224c-.075-.992-.798-1.77-1.677-1.84L34.167 8 13.897 8zM26 32a2 2 0 0 1 .233 3.987L26 36H16a2 2 0 0 1-.233-3.987L16 32h10zm6-6a2 2 0 0 1 .233 3.987L32 30H16a2 2 0 0 1-.233-3.987L16 26h16zm0-6a2 2 0 0 1 .233 3.987L32 24H16a2 2 0 0 1-.233-3.987L16 20h16zm-8.036-8c1.03 0 1.77.698 1.98 1.55l.038.2L26 14c0 .973-.674 1.711-1.51 1.934l-.196.042L24 16a1.995 1.995 0 0 1-1.989-1.771L22 14.018l.01-.204c.056-.538.33-1.02.736-1.345l.063-.046.038-.034c.255-.203.567-.338.909-.377l.208-.012z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInvoice);
export default __webpack_public_path__ + "static/media/icons-invoice.cd6153556867a15158a53009e39b403b.svg";
export { ForwardRef as ReactComponent };